module.exports = __webpack_public_path__ + "img/traveler-img-female.c8b90b6e.svg";